import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
const ConversationTabContent = ({
  classes,
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.tabContent
  }, children);
};
const styles = () => ({
  tabContent: {
    display: "flex",
    flexGrow: 1,
    overflow: "auto",
    minHeight: "2em"
  }
});
export default withStyles(styles)(ConversationTabContent);
ConversationTabContent.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node])
};